import * as React from "react"
import "../styles.css"
import * as pageStyles from "../page_css/page.css"
import * as styles from "./page-hero.css"
import { theme } from "../theme.css"
import { GatsbyImage, getImage, IGatsbyImageData } from "gatsby-plugin-image"
import { colorArrayToString } from "../utils"
import { TColor } from "../types"
import Flash from "../components/flash"
import StandardCard from "../components/blocks/StandardCard"
import TicketLink  from "../components/ticket-link"
import Bumbershoot2024BlueAnim from "../graphics/Bumbershoot-2024-blue-anim.svg"
import LineupNav from "../components/lineup-nav"
import * as headerHero2025Styles from "./header-hero-2025.css"

import {
  Text,
  Button,
} from "../components/ui"

import {
  NavLink,
  VisuallyHidden,
} from "./ui"
import * as stylesHeader from "./header.css"
import Badge from "./badge"
import { StaticImage } from "gatsby-plugin-image"
import HeaderHero2025 from "./header-hero-2025"

interface PageHeroProps {
  title: string
  subtitle?: string
  hidePageTitle?: boolean
  image: {
    id: string
    title: string
    gatsbyImageData?: any,
    localfile?: any
  },
  overlayColor?: string | TColor
  overlayOpacity?: string,
  showPageHero?: boolean,
  showPageHeroVideo?: boolean,
  heroVideoYoutubeUrl?: string,
  heroCard?: any,
  showHeroType?: string
  ticketLinks?: string
  path?: string
  location?: string
}

const VideoHero:React.FC<PageHeroProps> = (props) => {
  return (
    <>
    { props.heroVideoYoutubeUrl && (
      <>
        <div className={styles.customHomepageVideoBlock}>
          <iframe 
            className={styles.customHomepageVideoIframeWrapper}  
            src={props.heroVideoYoutubeUrl} 
            title="Bumbershoot Video" 
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
            allowFullScreen>
          </iframe>
        </div>
      </>
    )}
    </>
  )
}

const HeadlineHero:React.FC<PageHeroProps> = (props) => {
  return (
    <>
    { props.title && (props?.hidePageTitle !== true) && (
      <h1 className={styles.pageHeroTitle}>{props.title}</h1>
    )}
    { props.subtitle && (props?.hidePageTitle !== true) && (
      <h1 className={styles.pageHeroSubtitle}>{props.subtitle}</h1>
    )}

    </>
  )
}

// 2025 current live site - video is set via a card
// we're going to craft and entire homepage here from this card.


const CardHero:React.FC<PageHeroProps> = (props) => { 
  const { location } = props;
  
  const firstCardDataElement = props?.heroCard?.[0]?.card?.cardData?.[0] ?? null;

  if (!firstCardDataElement) {
    return null;
  }

  const { video: { video: videoObj = {} } = {}, videoThumbnail = {}, buttonText = '', title='', text='', hasButton=false } = firstCardDataElement; //video is a nested object btw.
  const { mp4Low = '', mp4Med = '' } = videoObj;
  const videoThumbnailSrc = videoThumbnail.gatsbyImageData?.images?.fallback?.src ?? "";
  const { ticketLinks } = props;

  const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 5
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1
  }
  };
  
  return (
    <>
      <div className={styles.customHomepageImageBlock}>
        {/*
        <GatsbyImage
          className={styles.pageHeroImage}
          style={{marginTop: '-100px'}}
          alt={props.image?.title ?? "Image"}
          image={getImage(props.image)}
        />
        */}
         <StaticImage
          src="../graphics/hero-images/aurora-homepage-v2.jpg"
          className={styles.pageHeroImage}
          style={{marginTop: '-60px'}}
              alt="thank you!"
              placeholder="blurred"
             // className={headerHero2025Styles.heroImage}
          />
          <div className={styles.overlayContent} style={{gap:"10px"}}>
            <div style={{width: "100%", height:"auto"}}>
              <h1 className={styles.heroTitleStyle} style={{color: '#f0f0f0'}}>Thank you Bumbershoot! </h1>
              
            <h1 className={styles.heroTitleStyleSmall} style={{color: '#f0f0f0'}}>See you in 2026.</h1>
            <h2 className={styles.heroTitleH2Style} style={{color: '#f0f0f0'}}>Be the first to know about pre-sale for Bumbershoot 2026</h2>
              <h1 className={styles.heroTitleStyleSmaller}></h1>
              <h1 className={styles.heroTitle2025Style}></h1>
              {
              /*
                <div style={{width: "200px", display: "inline-block"}}>
                  <Bumbershoot2024BlueAnim />
                </div>
              */
             }
            </div>
          
            <div className={styles.heroButtonWrapper}>
                <div className={styles.heroButton}>
                  <NavLink to="https://third-stone.hive-pages.com/emailsignup" target="_blank">
                    <VisuallyHidden>Sign up</VisuallyHidden>
                      <span className={styles.heroBadge}>
                       Sign up!
                      </span>
                  </NavLink>
                </div>
            </div>
            <div style={{width: "100vw", maxWidth:"700px"}} className={styles.heroTitle}></div>        
          </div>
      </div>

  { firstCardDataElement &&
  (
  <>

          <div className={styles.heroContainer}
            style={{
              backgroundColor: theme.colors.bumberNewsprint,
              paddingBottom: "40px",
            }}>

                  <div className={headerHero2025Styles.custom2025HeaderSchedule}>
                    <div className={headerHero2025Styles.scheduleImageColumn}>
                        <a href="/music-lineup">
                            <StaticImage
                              src="../graphics/schedule/Bumbershoot-MusicSchedule-Saturday-4x5.jpg"
                              alt="2025 Bumbershoot Saturday Music Schedule"
                              placeholder="blurred"
                              className={headerHero2025Styles.heroImage}
                          />
                      </a>
                    </div>
                    <div className={headerHero2025Styles.scheduleImageColumn}>
                      <a href="/music-lineup">
                        <StaticImage
                          src="../graphics/schedule/Bumbershoot-MusicSchedule-Sunday-4x5.jpg"
                          alt="2025 Bumbershoot Sunday Music Schedule"
                          placeholder="blurred"
                          className={headerHero2025Styles.heroImage}
                        />
                      </a>
                    </div>
                  </div>
                  <div className={headerHero2025Styles.custom2025HeaderSchedule}>
                    <div className={headerHero2025Styles.scheduleImageColumn}>
                      <a href="/artist-lineup">
                        <StaticImage
                          src="../graphics/schedule/Bumbershoot-ArtsSchedule-Saturday-4x5.jpg"
                          alt="2025 Bumbershoot Sunday Arts Schedule"
                          placeholder="blurred"
                          className={headerHero2025Styles.heroImage}
                        />
                      </a>
                    </div>
                    <div className={headerHero2025Styles.scheduleImageColumn}>
                      <a href="/artist-lineup">
                        <StaticImage
                          src="../graphics/schedule/Bumbershoot-ArtsSchedule-Sunday-4x5.jpg"
                          alt="2025 Bumbershoot Sunday Arts Schedule"
                          placeholder="blurred"
                          className={headerHero2025Styles.heroImage}
                        />
                      </a>
                    </div>
          </div>
          
          </div>

          <div className={headerHero2025Styles.custom2025HeaderHero} style={{
            marginBottom: "40px",
            backgroundColor: theme.colors.bumberInk,
          }}>


              {/*  ── Left column  */}
                <div className={headerHero2025Styles.heroImageColumn}>
                  <a href="/music-lineup">
                    <StaticImage
                      src="../graphics/admats/BBS_AdMat_Music_Digital_1200x1800_6_27.jpg"
                      alt="2025 Bumbershoot Music Admat"
                      placeholder="blurred"
                      className={headerHero2025Styles.heroImage}
                    />
                  </a>
              </div>

              {/*  ── Right column  */}
              <div className={headerHero2025Styles.heroImageColumn}>
                <a href="/artist-lineup">
                  <StaticImage
                    src="../graphics/admats/BBS_AdMat_Music_Arts_Digital_1200x1800_6_27.jpg"
                    alt="2025 Bumbershoot Arts Admat"
                    placeholder="blurred"
                    className={headerHero2025Styles.heroImage}
                  />
                </a>
              </div>
          </div>
          
    </>
  )}
  </>
  )
}

const PageHero: React.FC<PageHeroProps> = (props) => {
  const ticketLinks = TicketLink();
  const { showHeroType } = props;

  switch (showHeroType) { 
   // case "no_hero":
   //   return null;
    case "image_hero":
     // return (<ImageHero {...props} />);
    case "video_hero":
      return (<VideoHero {...props} />);
    case "card_hero":
      return (<CardHero {...props} ticketLinks={ticketLinks}/>);
    case "headline_hero":
      return (<HeadlineHero {...props} />);
    default:
      return (<HeadlineHero {...props} />);
  }

}

export default PageHero
